import {getDateDifference} from '@aboutyou/utils';
import React, {useEffect} from 'react';

export const useOnDoubleClick = ({
  ref,
  latency = 300,
  onDoubleClick = () => null,
}: {
  ref: React.RefObject<HTMLDivElement | null>;
  latency?: number;
  onDoubleClick: (e: TouchEvent) => void;
}) => {
  useEffect(() => {
    const clickRef = ref.current;
    let clickCount = 0;
    let currentDate = new Date();
    let lastTouch = currentDate;

    const onTouchStart = (e: TouchEvent) => {
      if (!e) {
        return;
      }

      if (e.touches.length > 1) {
        clickCount = 0;
        return;
      }

      currentDate = new Date();
      const difference = getDateDifference({
        start: lastTouch,
        end: currentDate,
        format: 'milliseconds',
      });

      if (difference > latency) {
        clickCount = 0;
      }

      clickCount++;
    };

    const onTouchEnd = (e: TouchEvent) => {
      if (e.changedTouches.length > 1) {
        clickCount = 0;
        return;
      }

      if (clickCount === 2) {
        clickCount = 0;
        onDoubleClick(e);
      }

      lastTouch = currentDate;
    };

    clickRef?.addEventListener('touchstart', onTouchStart);
    clickRef?.addEventListener('touchend', onTouchEnd);
    return () => {
      clickRef?.removeEventListener('touchstart', onTouchStart);
      clickRef?.removeEventListener('touchend', onTouchEnd);
    };
  }, []);
};
